import { render, staticRenderFns } from "./k-field-upload.vue?vue&type=template&id=31621550&scoped=true"
import script from "./k-field-upload.vue?vue&type=script&lang=js"
export * from "./k-field-upload.vue?vue&type=script&lang=js"
import style0 from "./k-field-upload.vue?vue&type=style&index=0&id=31621550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31621550",
  null
  
)

export default component.exports